<template>
  <div class="capacity-item">
    <div class="capacity-item__identity">
      <img v-if="modelIcon" :src="modelIcon" :alt="app.description" class="capacity-item__icon" />
      <span>{{ app.description }}</span>
    </div>

    <div class="capacity-item__footer">
      <span class="capacity-item__label">{{ t("instanceType") }}</span>
      <span class="p1">{{ deployedInstanceType }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from "@vue/composition-api"
import { IWorkspaceAsset } from "@/types/workspace"
import { useStore } from "@/composable/useStore"
import { createTranslationModule } from "@/plugins/i18n"

export default defineComponent({
  name: "CapacityItem",
  props: {
    app: {
      type: Object as PropType<IWorkspaceAsset>,
      required: true
    }
  },
  setup(props) {
    const { spaceModule } = useStore()
    const t = createTranslationModule("WorkspaceEdit.capacityCheck")

    const models = computed(() => {
      return spaceModule.assetModels
    })

    const deployedInstanceType = computed(() => {
      const instanceType = props.app.capacityReservation?.instanceType?.code
      const instanceFallback = props.app.allowedInstanceTypes[0]?.code || t("unknown")
      return instanceType || instanceFallback
    })

    const modelIcon = computed(() => {
      const model = models.value.find(m => m.key === props.app.type)

      if (model) {
        return model.icon
      }

      return false
    })

    return {
      t,
      deployedInstanceType,
      modelIcon
    }
  }
})
</script>
